import { render, staticRenderFns } from "./FactionWheel.vue?vue&type=template&id=76067f68&scoped=true&"
import script from "./FactionWheel.vue?vue&type=script&lang=ts&"
export * from "./FactionWheel.vue?vue&type=script&lang=ts&"
import style0 from "./FactionWheel.vue?vue&type=style&index=0&id=76067f68&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.9.6_fb85a9817f99bdf862e5e3a442a1fb91/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76067f68",
  null
  
)

export default component.exports